import { useContext } from "react";
import { ProveedorContext } from "../context/proveedor.context";

const useProveedor = () => {
    const proveedor = useContext(ProveedorContext);

    return proveedor;
};

export default useProveedor;
